import React from 'react';
import {
	Alert,
	Card,
	Col,
	Row,
} from 'antd';
import { CustomFieldParentTypes } from '@shared/utils/constants';
import { getUserData } from '@client/lib/api';
import useFetchedState from '@client/utils/hooks/useFetchedState';
import CustomFields from '../banking/CustomFields/CustomFields';
import CompanyAddress from './CompanyAddress';

const Invoicing = () => {
	const [userData] = useFetchedState(getUserData);

	return (
		<Row gutter={[16, 16]}>
			<Col span={12}>
				<Alert
					message="Custom fields will appear on the actual invoice"
					style={{ marginBottom: 10 }}
				/>
				<Card
					bordered
				>
					{userData?.organizationId != null && (
						<CustomFields
							parentId={userData.organizationId}
							parentType={CustomFieldParentTypes.ORG}
							showValueField={false}
						/>
					)}

				</Card>
			</Col>
			<Col span={12}>
				{' '}
				<Alert
					message="Company address & contact will appear on the actual invoice"
					style={{ marginBottom: 10 }}
				/>
				<Card
					bordered
				>
					{userData?.organizationId != null && (
						<CompanyAddress />
					)}

				</Card>
			</Col>
		</Row>
	);
};

export default Invoicing;
